<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <div>
    <vx-card ref="filterCard" class="user-list-filters mb-8" collapse-action>
      <ValidationObserver v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit">
          <div class="vx-row mb-2">
            <div class="vx-col w-1/3 flex">
              <div class="flex-1 pr-1">
                <label class="text-sm opacity-75">{{ $t("sections.report.dataForm.year") }}</label>
                <v-select v-model="form.year" :clearable="false" :options="yearsOptions" name="year" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
              </div>
              <div class="flex-1">
                <label class="text-sm opacity-75">{{ $t("sections.report.dataForm.month") }}</label>
                <v-select v-model="form.month" :clearable="false" :options="monthsOptions" name="month" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
              </div>
            </div>
            <div class="vx-col w-1/3">
              <validation-provider name="ประเภทรายงาน" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">ประเภทรายงาน*</label>
                <v-select v-model="form.reportType" :clearable="false" :options="reportDebtCollectionTypeOptions" name="reportType" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/6">
              <validation-provider name="ประเภทรายงาน" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">เฉพาะผู้กู้*</label>
                <v-select v-model="form.onlyBorrower" :clearable="false" :options="reportOnlyBorrowerOptions" name="reportType" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/6">
              <validation-provider name="ประเภทรายงาน" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">เฉพาะการดำเนินคดี*</label>
                <v-select v-model="form.prosecutionFilter" :clearable="false" :options="reportProsecutionFilterOptions" name="reportType" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row mb-2 flex">
            <div class="vx-col ml-auto">
              <vs-button color='success' @click="downloadExcel()" class="mr-2">{{ $t("general.download") }} (Excel)</vs-button>
              <vs-button color='success' @click="downloadPdf()" class="mr-2">{{ $t("general.download") }} (PDF)</vs-button>
              <vs-button color='warning' @click="reset()">{{ $t("general.reset") }}</vs-button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapGetters } from 'vuex'
import vSelect from 'vue-select'
import { getReportDate } from '@/utils'
const { mapState: mapReportState } = createNamespacedHelpers('Report')
const { mapActions: mapMasterActions, mapState: mapMasterState } = createNamespacedHelpers('Master')
const moment = require('moment');

export default {
  components: {
    vSelect
  },
  data () {
    return {
      reportServer: process.env.VUE_APP_REPORT_SERVER,
      form:{
        year: getReportDate().year,
        month: getReportDate().month,
        reportType: "reportDebtCollection30Day",
        onlyBorrower: "onlyBorrower",
        prosecutionFilter: "all",
      },
    }
  },
  computed: {
    ...mapReportState([ 'status']),
    ...mapMasterState(["curriculums", "months"]),
    ...mapGetters({
      yearsOptions: "Master/yearsOptions",
      monthsOptions: "Master/monthsOptions",
      reportDebtCollectionTypeOptions: "Report/reportDebtCollectionTypeOptions",
      reportOnlyBorrowerOptions: "Report/reportOnlyBorrowerOptions",
      reportProsecutionFilterOptions: "Report/reportProsecutionFilterOptions",
    }),
  },
  methods: {
    ...mapMasterActions(['onChangeYears', 'getProjectOptions', 'getCurriculumOptions']),
    _onChangeYears(e) {
      this.onChangeYears(e)
    },
    async loadOptions() {

    },
    async initData() {
      this.form.reportType = this.reportDebtCollectionTypeOptions[0].value
    },
    async downloadExcel (){
      const vm = this
      vm.$refs['form'].validate().then(async success => {
        if (!success) {
          return
        }
        const params = {
          year: vm.form.year,
          month: vm.form.month,
          onlyBorrower: vm.form.onlyBorrower,
          prosecutionFilter:  vm.form.prosecutionFilter,
        };

        const queryString = new URLSearchParams(params).toString();
        window.open(`${vm.reportServer}/excel/${vm.form.reportType}?${queryString}`, '_blank');
      })
    },
    async downloadPdf (){
      const vm = this
      vm.$refs['form'].validate().then(async success => {
        if (!success) {
          return
        }
        const params = {
          year: vm.form.year,
          month: vm.form.month,
          onlyBorrower: vm.form.onlyBorrower,
          prosecutionFilter:  vm.form.prosecutionFilter,
        };

        const queryString = new URLSearchParams(params).toString();
        window.open(`${vm.reportServer}/pdf/${vm.form.reportType}?${queryString}`, '_blank');
      })
    },
    async reset(){
      this.form = {
        year: moment().add(-1, 'M').format("YYYY"),
        month: parseInt(moment().add(-1, 'M').format("MM"))-1,
        reportType: '',
      }
    },
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  },
  async created() {
    const vm = this
    vm.$vs.loading();
    await vm.loadOptions();
    await vm.initData();
    vm.$vs.loading.close();
  },
}
</script>
